export default {
  name: "pro-action-more-item",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    moreVisible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("close-more");
      this.item.click();
    },
    oncancel() {
      this.$emit("close-more");
    }
  }
};